import { toast } from "sonner";
import { Copy } from "lucide-react";
import { hexToRgb, rgbToCmyk } from "@/lib/brand";

export const copyText = async (text, what) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(`${what} copied`);
  } catch {
    toast.error(`Couldn't copy automatically. Select and copy it instead: ${text}`, { duration: 30000 });
  }
};

export const ColourSwatch = ({ colour }) => {
  const rgb = hexToRgb(colour.hex);
  const slug = colour.name.toLowerCase().replace(/\s+/g, "-");
  return (
    <article className="overflow-hidden rounded-3xl border border-sky-100 bg-white" data-testid={`brand-colour-${slug}`}>
      <div className="h-24 border-b border-sky-100" style={{ background: colour.hex }} />
      <div className="p-4">
        <div className="flex items-center justify-between gap-2">
          <h3 className="font-display text-base font-semibold text-ink">{colour.name}</h3>
          <button onClick={() => copyText(colour.hex, colour.hex)} className="inline-flex items-center gap-1 rounded-full px-2 py-1 font-mono text-xs text-sky-700 hover:bg-sky-50" aria-label={`Copy ${colour.hex}`} data-testid={`brand-colour-${slug}-copy`}>
            <Copy className="h-3 w-3" />{colour.hex}
          </button>
        </div>
        <p className="mt-1 text-xs text-slate-600">{colour.role}</p>
        <dl className="mt-3 space-y-0.5 font-mono text-[12px] text-slate-700">
          <div className="flex justify-between"><dt className="text-slate-500">RGB</dt><dd>{rgb.join(" ")}</dd></div>
          <div className="flex justify-between"><dt className="text-slate-500">CMYK*</dt><dd>{rgbToCmyk(rgb).join(" ")}</dd></div>
        </dl>
      </div>
    </article>
  );
};
